export const itemTypes: Record<string, Record<string, string>> = {
  templates: {
    name: 'Template',
    icon: 'note',
  },
  notes: {
    name: 'Note',
    icon: 'note-01',
  },
  blocks: {
    name: 'Block',
    icon: 'blockchain-01',
  },
  instructions: {
    name: 'Instruction',
    icon: '3rd-bracket',
  },
  tags: {
    name: 'Tag',
  },
  userSources: {
    name: 'Source',
    icon: 'file-01',
  },
};

export const getSelectedItemType = (type: string) => {
  return itemTypes[type]?.name?.toLowerCase() || 'item';
};
